!(function moduleLoader(modules, cache, entryPoints) {
  function require(moduleId, requireContext) {
    if (!cache[moduleId]) {
      if (!modules[moduleId]) {
        var fallbackRequire = typeof require === "function" && require;
        if (!requireContext && fallbackRequire)
          return fallbackRequire(moduleId, true);
        if (defaultRequire) return defaultRequire(moduleId, true);
        throw new Error("Cannot find module '" + moduleId + "'");
      }
      var module = (cache[moduleId] = { exports: {} });
      modules[moduleId][0].call(
        module.exports,
        function (importedId) {
          var resolvedId = modules[moduleId][1][importedId];
          return require(resolvedId || importedId);
        },
        module,
        module.exports,
        moduleLoader,
        modules,
        cache,
        entryPoints
      );
    }
    return cache[moduleId].exports;
  }

  for (
    var defaultRequire = typeof require === "function" && require, index = 0;
    index < entryPoints.length;
    index++
  )
    require(entryPoints[index]);

  return require;
})(
  {
    1: [
      function (require, module, exports) {
        "use strict";
        var mainContent = document.querySelector('[id^="MainContent"]'),
          skipLink = document.querySelector(".skipLink");

        document.addEventListener("DOMContentLoaded", () => {
          if (mainContent && skipLink) {
            skipLink.setAttribute("href", "#" + mainContent.getAttribute("id"));
            skipLink.addEventListener("click", (event) => {
              event.preventDefault();
              console.log("click", mainContent);
              mainContent.scrollIntoView({ behavior: "smooth" });
            });
          } else if (skipLink) {
            skipLink.remove();
          }
        });
      },
      {},
    ],
  },
  {},
  [1]
);
